<!-- eslint-disable vue/require-v-for-key -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
/* eslint length-zero-no-unit "error" */

<template>
  <div v-if="rows.length" class="addWorkPackage table-wrapper">
    <div class="tableAddWorkPackage">
      <table
        v-for="(row, index) in rows"
        :key="`addWorkPackage-price-${_uid}-row-${index}`"
        class="tableAddWorkPackage__row"
      >
        <tr class="main">
          <td class="tableAddWorkPackage__col-checkbox">
            <BaseCheckbox
              v-model="workpackages[row.id]"
              :validate="exclude_packages.includes(row.exclude_id)"
              :customHandler="customHandlerCheckbox(row)"
            />
          </td>
          <td class="tableAddWorkPackage__col">
            <div class="tableAddWorkPackage__col-text">
              {{ row.label }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              <!-- {{ row.duration }} -->
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              {{ row.price }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col">
            <div
              class="tableAddWorkPackage__col-text tableAddWorkPackage__col_chevron"
              :class="[{ 'active-collapse': !checkCollapse(index, row) }]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                @click="() => openCollapse(index, row)"
              >
                <path
                  d="M17 14.25C16.8081 14.25 16.6162 14.1768 16.4697 14.0303L10 7.56055L3.53027 14.0303C3.2373 14.3232 2.7627 14.3232 2.46973 14.0303C2.17676 13.7373 2.17676 13.2627 2.46973 12.9697L10 5.43945L17.5303 12.9697C17.8232 13.2627 17.8232 13.7373 17.5303 14.0303C17.3838 14.1768 17.1919 14.25 17 14.25Z"
                  fill="#101010"
                />
              </svg>
            </div>
          </td>
        </tr>
        <tr
          v-for="rowWork in row.add_works"
          v-if="checkCollapse(index, row)"
          class="tableAddWorkPackage__row"
        >
          <td class="tableAddWorkPackage__col-checkbox" />
          <td class="tableAddWorkPackage__col">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.label }} {{ rowWork.quantity }} {{ rowWork.unit }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.duration }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.price }}
            </div>
          </td>
          <td />
        </tr>

        <tr
          v-for="rowWork in row.add_parts"
          v-if="checkCollapse(index, row)"
          class="tableAddWorkPackage__row"
        >
          <td class="tableAddWorkPackage__col-checkbox" />
          <td class="tableAddWorkPackage__col">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.label }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.duration }} {{ rowWork.quantity }} {{ rowWork.unit }}
            </div>
          </td>
          <td class="tableAddWorkPackage__col noWrap">
            <div class="tableAddWorkPackage__col-text">
              {{ rowWork.price }}
            </div>
          </td>
          <td />
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'AddWorkPackageAddWorkPackage',
    props: {
      rows: {
        type: Array,
        required: true
      },
      excludePackageMessage: {
        type: String
      }
    },
    data () {
      let collapsed = []
      this.rows.map((item, index) => {
        collapsed = [ ...collapsed, index ]
      })
      return {
        collapsed: collapsed,
        workpackages: {},
        exclude_packages: [],
        exclude_packagesIds: []
      }
    },
    watch: {
      '$route.query.workpackages': {
        handler: function (v) {
          if (v === undefined) {
            this.workpackages = {}
            this.$store.commit('SET_WORKPACKAGES', '')
          }
        },
        deep: true,
        immediate: true
      },
      workpackages: {
        handler () {
          this.exclude_packages = []
          this.exclude_packagesIds = []
          this.rows.forEach(item => {
            if (Object.keys(this.filterBooleanProperties(this.workpackages)).includes(item.id)) {
              this.exclude_packages = [...this.exclude_packages, ...item.exclude_packages]
              this.exclude_packagesIds = [ ...this.exclude_packagesIds, {
                id: item.id,
                label: item.label,
                exclude_packages: item.exclude_packages
              }]
            }
          })

          const accessIds = []
          for (const property in this.workpackages) {
            if (this.workpackages[property]) {
              accessIds.push(property)
            }
          }
          const lang = this.$store.state.currentLang
          const queryLang = lang !== DEFAULT_LANG ? { lang } : {}

          const newQuery = {
            ...this.$route.query,
            workpackages: accessIds.length ? accessIds.join(',') : undefined,
            ...queryLang
          }

          if (JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)) {
            this.$router.push({ path: this.$route.path, query: newQuery })
          }
          this.$store.commit('SET_WORKPACKAGES', accessIds.join(','))
        },
        deep: true
      }
    },
    beforeMount () {
      if (this.$route.query.workpackages) {
        this.$store.commit('SET_WORKPACKAGES', this.$route.query.workpackages)
        this.$route.query.workpackages.split(',').forEach(item => {
          this.$set(this.workpackages, +item, true)
        })
      }
    },
    methods: {
      filterBooleanProperties (obj) {
        const filteredObj = {}
        for (const key in obj) {
          if (obj[key] === true) {
            filteredObj[key] = obj[key]
          }
        }
        return filteredObj
      },
      customHandlerCheckbox (item) {
        const modal = this.$modal
        const excludePackageMessage = this.excludePackageMessage
        const excludePackagesIds = this.exclude_packagesIds
        return function () {
          const labelCurrent = excludePackagesIds.filter(itemIds => itemIds.exclude_packages.includes(item.exclude_id))[0].label
          modal.show('work-modal', {
            text: excludePackageMessage.replace('{selectedPackage}', labelCurrent).replace('{excludedPackage}', item.label)
          })
        }
      },
      openCollapse (id) {
        if (this.collapsed.includes(id)) {
          this.collapsed = this.collapsed.filter(item => item !== id)
        } else {
          this.collapsed = [...this.collapsed, id]
        }
      },
      checkCollapse (id) {
        return !this.collapsed.includes(id)
      }
    }
  }
</script>

<style lang="scss">
.addWorkPackage {
  background: initial !important;
  padding: 0 0 30px 0;
  @media (max-width: 767px) {
    padding: 0 0 25px 0;
  }
  .table-wrapper {
    padding: 0;
  }
}

.tableAddWorkPackage {
  .checkbox__custom {
    border-radius: unset;
    border-color: #c7cfd7;
  }

  table {
    width: 100%;
    display: contents;
  }

  .main {
    td {
      div {
        font-weight: 600;
        font-family: "FavoritBookC", Arial, Helvetica, sans-serif;
      }
    }
  }

  &-wrapper {
    padding: 30px 0;
    background: $c-white;

    @include mobile {
      padding: 0;
      padding-bottom: 25px;
      overflow-x: scroll;
    }
  }

  width: 100%;

  &__col {
    padding: 4px 0;
    padding-right: 24px;
    line-height: 24px;
    font-size: 16px;
    text-align: left;
    vertical-align: middle;

    &.noWrap {
      white-space: nowrap;
      text-align: end;

      div {
        white-space: nowrap;
      }
    }

    svg {
      cursor: pointer;
    }

    &_custom-style {
      font-size: 12px;
    }

    @include mobile {
      padding: 10px 0;
      padding-right: 25px;
    }

    &:nth-child(2) {
      width: 100%;
      text-align: left;
      padding-left: 0px;
    }

    &:last-child {
      padding-right: 0;

      @include mobile {
        padding-right: 0;

        svg {
          background-color: $c-gray-light;
          position: absolute;
          right: 12px;
          height: 40px;
        }
      }
    }

    &-checkbox {
      max-width: 40px;
      min-width: 40px;
      min-height: 20px;
      max-height: 20px;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      position: relative;
      top: 6px;

      @include mobile {
        top: 15px;
      }
    }

    &-text {
      display: inline-flex;
      align-items: center;
      // max-width: 290px;
      color: $c-gray-dark;
      font-family: "ToyotaType", Arial, Helvetica, sans-serif;
      font-weight: 400;

      &-select {
        min-width: 100px !important;
        // max-width: 100px !important;
        padding: 0 !important;
        margin-left: 15px;

        .select__arrow {
          right: 10px;
        }

        .select__dropdown {
          top: 100% !important;
          width: auto;

          @include no-scrollbar;
        }
      }

      @include mobile {
        font-size: 14px;
      }
    }

    &-subtext {
      max-width: 290px;
      font-size: 12px;
      color: $c-gray-dark;
      opacity: 0.7;

      @include mobile {
        font-size: 10px;
      }
    }

    &_chevron {
      svg {
        transform: translateY(4px);

        @include mobile {
          transform: translateY(-4px);
        }
      }

      &.active-collapse {
        svg {
          transform: translateY(4px) rotate(180deg);

          @include mobile {
            transform: translateY(-4px) rotate(180deg);
          }
        }
      }
    }
  }

  &__row {
    &:first-child {
      width: 10px;
    }

    &:nth-child(2) {
      .table__col-text {
        font-size: 18px;
        font-weight: 900;
        color: $c-black;

        @include mobile {
          font-size: 16px;
        }
      }
    }
  }

  &__expand-button-container {
    display: flex;
    justify-content: center;
    margin-top: 25px;
  }
}

.addWorkPackage-price {
  padding: 45px 40px;
  background: $c-white;

  @include mobile {
    padding: 15px 20px;
  }

  &__warning {
    margin-top: 20px;
    font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
    font-size: 13px;
    line-height: 18px;
    color: $c-input-grey;
  }

  &__duration {
    @media (min-width: 768px) {
      width: 15%;
    }

    @media (max-width: 767px) {
      min-width: 40px;
    }

    span {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
      color: $c-gray-dark;
      font-family: "ToyotaType-Semibold", Arial, Helvetica, sans-serif;
    }
  }

  &__price {
    @media (min-width: 768px) {
      width: 15%;
    }

    @media (max-width: 767px) {
      min-width: 120px;
      text-align: end;
    }

    white-space: nowrap;

    span {
      font-size: 16px;
      font-weight: 600;
      font-family: "ToyotaType-Semibold", Arial, Helvetica, sans-serif;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
      color: $c-gray-dark;
    }
  }

  &__arrow {
    // width: 10%;
    cursor: pointer;
  }

  &__label {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    &-text {
      color: $c-gray-dark;

      @include mobile {
        font-size: 14px;
      }
    }
  }

  &__value {
    width: 20%;
    color: inherit;
    text-align: center;

    @include mobile {
      width: 35%;
      font-size: 14px;
    }

    @include mobileXs {
      width: 40%;
      font-size: 14px;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    color: $c-gray-dark;
    gap: 24px;
    width: 100%;
    flex: 1 1 auto;
    //justify-content: flex-end;

    @include mobile {
      margin-bottom: 15px;
    }

    &_last {
      position: relative;
      align-items: flex-start;
      padding-top: 24px;
      margin-bottom: 0;
      font-weight: 900;
      color: $c-black;

      @include mobile {
        padding-top: 15px;
      }

      &::before {
        position: absolute;
        top: 0;
        left: -40px;
        width: calc(100% + 80px);
        height: 1px;
        content: "";
        background: $c-gray;

        @include mobile {
          left: -20px;
          width: calc(100% + 40px);
        }
      }

      .addWorkPackage-price__label {
        &-text {
          font-size: 18px;
          color: $c-black;

          @include mobile {
            font-size: 16px;
          }
        }
      }

      .addWorkPackage-price__value {
        font-size: 18px;

        @include mobile {
          font-size: 16px;
        }
      }
    }
  }

  &_no-padding {
    padding: 0;

    .addWorkPackage-price__row:last-child::before {
      left: 0;
      width: 100%;
    }
  }
}
</style>
